/**
 * Jellybean cart bundle controls
 * Removes every component line in a displayed set with one action.
 */
(function () {
  'use strict';

  function getBundleCounts(bundle) {
    return Array.from(bundle.querySelectorAll('[data-bundle-item-type]')).reduce(function(counts, item) {
      var type = item.dataset.bundleItemType || '';
      var quantity = parseInt(item.dataset.bundleItemQuantity || '0', 10);
      if (isNaN(quantity)) quantity = 0;

      if (type === 'table') counts.tables += quantity;
      if (type === 'chair' || type === 'chair-1' || type === 'chair-2') counts.chairs += quantity;
      return counts;
    }, { tables: 0, chairs: 0 });
  }

  function setCheckoutIntegrityState(isValid) {
    document.body.classList.toggle('jb-cart-has-invalid-bundle', !isValid);

    document.querySelectorAll('button[name="checkout"]').forEach(function(button) {
      if (!isValid) {
        if (!button.disabled) button.dataset.jbBundleDisabled = 'true';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else if (button.dataset.jbBundleDisabled === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        delete button.dataset.jbBundleDisabled;
      }
    });
  }

  function validateDisplayedBundles() {
    var bundles = Array.from(document.querySelectorAll('[data-jb-cart-bundle]'));
    var allValid = true;

    bundles.forEach(function(bundle) {
      var counts = getBundleCounts(bundle);
      var valid = counts.tables === 1 && counts.chairs === 2;
      var status = bundle.querySelector('[data-jb-bundle-status]');

      bundle.classList.toggle('is-invalid', !valid);
      bundle.dataset.bundleValid = valid ? 'true' : 'false';
      if (status) {
        status.textContent = valid
          ? ''
          : 'This set is incomplete. Please remove it and rebuild the set before checkout.';
      }
      if (!valid) allValid = false;
    });

    setCheckoutIntegrityState(allValid);
    return allValid;
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-jb-remove-bundle]');
    if (!button) return;

    const bundle = button.closest('[data-jb-cart-bundle]');
    if (!bundle || button.disabled) return;

    const lineKeys = Array.from(bundle.querySelectorAll('[data-item]'))
      .map(item => item.dataset.item)
      .filter(Boolean);
    if (!lineKeys.length) return;

    const status = bundle.querySelector('[data-jb-bundle-status]');
    const originalText = button.textContent;
    const updates = {};
    lineKeys.forEach(key => { updates[key] = 0; });

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Removing set...';
    if (status) status.textContent = '';

    try {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      });

      if (!response.ok) throw new Error('Bundle removal failed');
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
      if (status) status.textContent = 'We could not remove the set. Please try again.';
    }
  });

  document.addEventListener('submit', function(event) {
    if (!event.target.matches('[data-cart-form]')) return;
    if (validateDisplayedBundles()) return;

    event.preventDefault();
    var invalidBundle = document.querySelector('[data-jb-cart-bundle].is-invalid');
    if (invalidBundle) invalidBundle.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  document.addEventListener('theme:cart:refresh', function() {
    window.setTimeout(validateDisplayedBundles, 250);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      validateDisplayedBundles();
      observeCartChanges();
    });
  } else {
    validateDisplayedBundles();
    observeCartChanges();
  }

  function observeCartChanges() {
    var cartRoot = document.querySelector('[data-cart-page]');
    if (!cartRoot || cartRoot.dataset.jbBundleObserved === 'true') return;
    cartRoot.dataset.jbBundleObserved = 'true';

    var validationTimer = null;
    new MutationObserver(function() {
      window.clearTimeout(validationTimer);
      validationTimer = window.setTimeout(validateDisplayedBundles, 50);
    }).observe(cartRoot, { childList: true, subtree: true });
  }
})();
